const getViteEnv = () =>
  typeof import.meta !== "undefined" && import.meta.env ? import.meta.env : {};

const getNodeEnv = () =>
  typeof process !== "undefined" && process.env ? process.env : {};

const resolveEnvValue = key => {
  const viteEnv = getViteEnv();
  const nodeEnv = getNodeEnv();
  if (viteEnv[key]) {
    return viteEnv[key];
  }
  if (nodeEnv[key]) {
    return nodeEnv[key];
  }
  return "";
};

export const getBuildMeta = () => ({
  buildDate:
    resolveEnvValue("VITE_BUILD_DATE") || resolveEnvValue("BUILD_DATE") || "",
  commitHash:
    resolveEnvValue("VITE_COMMIT_HASH") || resolveEnvValue("COMMIT_HASH") || "",
});
